function getAllEnumProps(obj, propsBuffer) {
  if (obj == null) return;
  Object.keys(obj).forEach((prop) => propsBuffer.push(prop));
  Object.keys(obj.constructor).forEach((prop) => propsBuffer.push(prop));
  getAllEnumProps(Object.getPrototypeOf(obj), propsBuffer);
}


const version = '2.0';


class ZForms {
  constructor() {
    this.version = version;
    this.registeredClasses = {
      classes: {},
    };
  }

  registerClass(classType, newClass) {
    if (newClass == null) throw new Error('newClass is null!');

    if (classType == null || classType == '') throw new Error(classType + ' is empty!');

    // if (this.registeredClasses[classType] != null) throw new Error(classType + ' already exists!');
    newClass.zfType = classType;

    const CurNewClass = newClass;

    newClass = function() {
      const ans = new CurNewClass(...arguments);
      const staticProps = [];
      getAllEnumProps(CurNewClass, staticProps);
      staticProps.forEach((field) => ans[field] = CurNewClass[field]);
      return ans;
    };

    if (this.registeredClasses.levelClass == null && classType == 'entity') {
      this.registeredClasses.levelClass = newClass;
    }

    let curLevel = this.registeredClasses;

    String(classType).split('.').forEach((classObj) => {
      curLevel.classes[classObj] = curLevel.classes[classObj] == null ? {classes: {}} : curLevel.classes[classObj];
      curLevel = curLevel.classes[classObj];
    });

    curLevel.levelClass = newClass;

    return CurNewClass;
  }

  async parseRaw(rawData, baseMeta) {
    let zfType = (
      baseMeta == null && rawData.__meta__ == null ? '' :
      baseMeta == null ? rawData.__meta__.zf_type :
      rawData[baseMeta.metaAttrName] == null ? baseMeta.zfType :
      rawData[baseMeta.metaAttrName].zf_type
    );

    if (zfType == null) zfType = '';

    let curLevel = this.registeredClasses;
    let lastClass = curLevel.levelClass;

    String(zfType).split('.').forEach((classObj) => {
      if (curLevel.classes[classObj] == null) return;
      curLevel = curLevel.classes[classObj];
      lastClass = curLevel.levelClass == null ? lastClass : curLevel.levelClass;
    });
    const classArgs = Array.from(arguments);
    classArgs.splice(0, 1);
    // eslint-disable-next-line new-cap
    const curInstance = new lastClass(...classArgs);
    const ans = await (curInstance.updateFromRaw(rawData));
    ans.rawZFType = zfType;
    return ans;
  }
}

ZForms.version = version;

window.ZForms = new ZForms();

// eslint-disable-next-line no-extend-native
Object.defineProperty(Object.prototype, 'isZEntityType', {
  value: function isZEntityType(checkType) {
    return String(this.zfType).startsWith(checkType);
  },
});

export default window.ZForms;
